export const COMPANY_INFO = {
  name: {
    korean: '(주)센터소프텍',
    english: 'CenterSoftech'
  },
  contact: {
    email: 'hello@centersoftech.com'
  }
};
